import {changePassword} from '../../js/api/profile.js';
import { _t } from '../../services/TranslationService.js';

let ChangePassword = {
    render : async () => {
        let view =  /*html*/`
            <div class="changePasswordHeader m-t-6">
                 <a class="backBtn">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                 </a>
                 <span>${_t('Ndrysho Fjalekalimin')}</span>
           </div>
           <div class="changePasswordWrapper m-t-6">
                <div class="changePasswordHolder">
                  <!--   <p>Notice! Use 1 uppercase Letter, minimum 8 characters bla bla.</p>-->
                    <input type="password" placeholder="${_t('Fjalekalimi i vjeter')}" id="oldPassword">
<!--                    <span class="errorMsg">Error Old Password</span>-->
                    <input type="password" placeholder="${_t('Fjalekalimi i ri')}" id="newPassword">
<!--                    <span class="errorMsg">No Error</span>-->
                    <input type="password" placeholder="${_t('Perserit Fjalekalimin')}" id="repeatPassword">
<!--                    <span class="errorMsg">No Error</span>-->
                    <a class="changePassowrdBtn" id="changePassowrdBtn">${_t('Regjistro')}</a>
                </div>
            </div>
       `
        return view
    }
    , after_render: async () => {
        const submitBtn = document.getElementById('changePassowrdBtn');

        submitBtn.addEventListener('click', async () => {
            const old_password = document.getElementById('oldPassword').value;
            const new_password = document.getElementById('newPassword').value;
            const new_password_repeat = document.getElementById('repeatPassword').value;

            // Check if password has 8 characters, and includes at least one number and one letter
            if (new_password.length < 8 || !/\d/.test(new_password) || !/[a-zA-Z]/.test(new_password)) {
              alert(_t("Password must be at least 8 characters long and include at least one number!"));
              return;
            }

            // Check if password have at least one special character
            if (!/[!@#$%^&*]/.test(new_password)) {
              alert(_t("Password must include at least one special character!"));
              return;
            }

            var res = await changePassword({
                new_password,
                new_password_repeat,
                old_password
            });

            if (res && res.message) {
                alert(res.message);
            }
          });
    }

}

export default ChangePassword;